"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeCustomerResultWithAddressBookToJSON = exports.ChangeCustomerResultWithAddressBookFromJSONTyped = exports.ChangeCustomerResultWithAddressBookFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ChangeCustomerResultWithAddressBookFromJSON(json) {
    return ChangeCustomerResultWithAddressBookFromJSONTyped(json, false);
}
exports.ChangeCustomerResultWithAddressBookFromJSON = ChangeCustomerResultWithAddressBookFromJSON;
function ChangeCustomerResultWithAddressBookFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customer': !(0, runtime_1.exists)(json, 'customer') ? undefined : (0, _1.CustomerDataFromJSON)(json['customer']),
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
        'addressBook': !(0, runtime_1.exists)(json, 'addressBook') ? undefined : (json['addressBook'].map(_1.AddressWithIdFromJSON)),
        'inlineErrors': !(0, runtime_1.exists)(json, 'inlineErrors') ? undefined : (0, _1.AddressInlineErrorMessagesFromJSON)(json['inlineErrors']),
    };
}
exports.ChangeCustomerResultWithAddressBookFromJSONTyped = ChangeCustomerResultWithAddressBookFromJSONTyped;
function ChangeCustomerResultWithAddressBookToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customer': (0, _1.CustomerDataToJSON)(value.customer),
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
        'addressBook': value.addressBook === undefined ? undefined : (value.addressBook.map(_1.AddressWithIdToJSON)),
        'inlineErrors': (0, _1.AddressInlineErrorMessagesToJSON)(value.inlineErrors),
    };
}
exports.ChangeCustomerResultWithAddressBookToJSON = ChangeCustomerResultWithAddressBookToJSON;
//# sourceMappingURL=ChangeCustomerResultWithAddressBook.js.map